import './sj-root.js';

// import "./sj-Engine/sj-libraries/p5.js";
// import "./sj-Engine/sj-libraries/p5.sound.js";

// SJ._loadEngine
import './sj-Engine/sj-libraries/matter.js';
import './sj-Engine/sj-Tools/sj-CanvasScaler.js';
import './sj-Engine/sj-Tools/sj-InputManager.js';
import './sj-Engine/sj-Tools/sj-ImageLoader.js';
import './sj-Engine/sj-Tools/sj-PullingSystem.js';
import './sj-Engine/sj-Tools/sj-AirSystem.js';
import './sj-Engine/sj-Tools/sj-LocationManager.js';
import './sj-Engine/sj-Tools/sj-ParalaxBackground.js';
import './sj-Engine/sj-Tools/sj-ParalaxLayer.js';
import './sj-Engine/sj-Tools/sj-CameraPath.js';
import './sj-Engine/sj-Tools/sj-SpriteSheet.js';
import './sj-Engine/sj-Tools/sj-VariablesSliders.js';
import './sj-Engine/sj-Tools/sj-Camera.js';
import './sj-Engine/sj-Tools/sj-EventHandler.js';
import './sj-Engine/sj-Tools/sj-MovingObjects.js';
import './sj-Engine/sj-Tools/sj-LoadingScreen.js';
import './sj-Engine/sj-Tools/sj-Tools.js';
import './sj-Engine/sj-Tools/sj-ControlJoystick.js';

import './sj-Engine/sj-Animations/sj-Animation.js';
import './sj-Engine/sj-Animations/sj-AnimationPlayer.js';
import './sj-Engine/sj-Animations/sj-LightPath.js';
import './sj-Engine/sj-Animations/sj-ParticleSystem.js';

import './sj-Engine/sj-Sound/sj-Sound.js';
import './sj-Engine/sj-Sound/sj-SoundManager.js';
import './sj-Engine/sj-UI/sj-Screen.js';
import './sj-Engine/sj-UI/sj-UI.js';

import './sj-Engine/sj-items/sj-Item.js';
import './sj-Engine/sj-items/sj-ItemsManager.js';

// SJ._loadGame
import './sj-tools/sj-PadCreator.js';
import './sj-tools/sj-ScoreCounter.js';
import './sj-tools/sj-MessagesManager.js';
import './sj-tools/sj-Variables.js';
import './sj-tools/sj-PlayerData.js';
import './sj-tools/sj-login.js';
import './sj-tools/sj-StartWalkSystem.js';
import './sj-Engine/sj-Tools/sj-Weather.js';
import './sj-objects/sj-MainClass.js';
import './sj-objects/sj-Tournament.js';
import './sj-UI/sj-ScreensManager.js';
import './sj-UI/sj-UIElements.js';

import './sj-objects/ski/sj-LaunchingPad.js';
import './sj-objects/ski/sj-Jumper.js';
import './sj-objects/space/sj-LaunchingPad.js';
import './sj-objects/space/sj-Jumper.js';

window.preload = function () {
	SJ.mainFont = loadFont('skijump-js/sj-fonts/Amiko-Bold.ttf');
	SJ.dailyBonusFont = loadFont('skijump-js/sj-fonts/BebasNeue-Regular.ttf');
	// window.scrollTo(0, 9999);
	// document.querySelector('body').style.overflow = 'hidden';
};

window.setup = function () {
	frameRate(parseInt(SJ.settings.framerate));
	// frameRate(60);

	noStroke(); //usunięcie obramowań
	// textFont('Roboto');
	textFont(SJ.mainFont);

	SJ.loadingScreenImages = {
		Szczyrk: loadImage('skijump-js/sj-graphics/loading/szczyrk.jpg'),
		Oberstdorf: loadImage('skijump-js/sj-graphics/loading/oberstdorf.jpg'),
		Zakopane: loadImage('skijump-js/sj-graphics/loading/zakopane.jpg'),
		Vikersund: loadImage('skijump-js/sj-graphics/loading/vikersund.jpg'),
		Planica: loadImage('skijump-js/sj-graphics/loading/planica.jpg'),
		'Pekin 2030': loadImage('skijump-js/sj-graphics/loading/pekin.jpg'),
	};

	SJ.loadingScreenImage = loadImage(
		'skijump-js/sj-graphics/loading-screen-bgr.jpg'
	);

	SJ._loadScripts(() => {
		SJ.settings.graphic = SJ.Tools.cookieValue('graphicsSettings') || 'low';

		if (SJ.IS_MOBILE) {
			SJ.settings.graphic = 'ultralow';
		}

		SJ.on.callArray('_preloadCallbacs');
		SJ.on.callArray('_loadCallbacs');

		const canvas = createCanvas(SJ.SCREEN_WIDTH, SJ.SCREEN_HEIGHT);
		canvas.parent('skijump-game-container');

		SJ.canvasScaler = new SJ.CanvasScaler();
		SJ.canvasScaler.setup();

		SJ.slidersManager = new SJ.VariableSlidersManager();
		setupInputManager();

		SJ.soundManager = new SJ.SoundContainer('soundManager', true);

		SJ.SFXSoundManager = new SJ.SoundContainer('SFXSoundManager');
		SJ.soundManager.addContainer(SJ.SFXSoundManager);

		SJ.gameSoundsContainer = new SJ.SoundContainer('gameSoundsContainer');
		SJ.SFXSoundManager.addContainer(SJ.gameSoundsContainer);

		SJ.jumperSoundContainer = new SJ.SoundContainer('jumperSoundsContainer');
		SJ.SFXSoundManager.addContainer(SJ.jumperSoundContainer);

		SJ.jumperSoundContainer.createSound(
			'speedUp',
			'jumper/Zjazd.mp3',
			0.2,
			false,
			false
		);
		SJ.jumperSoundContainer.createSound(
			'jump1',
			'jumper/Wyskok 1.mp3',
			0.1,
			false,
			false
		);
		SJ.jumperSoundContainer.createSound(
			'jump2',
			'jumper/Wyskok 2.mp3',
			0.1,
			false,
			false
		);
		SJ.jumperSoundContainer.createSound(
			'fly',
			'jumper/Lot.mp3',
			0.2,
			true,
			false
		);
		SJ.jumperSoundContainer.createSound(
			'landing',
			'jumper/Ladowanie.mp3',
			0.1,
			false,
			false
		);
		SJ.jumperSoundContainer.createSound(
			'lightHit',
			'jumper/Upadek lekki.mp3',
			0.1,
			false,
			false
		);
		SJ.jumperSoundContainer.createSound(
			'havyHit',
			'jumper/Upadek ciezki.mp3',
			0.1,
			false,
			false
		);
		SJ.jumperSoundContainer.createSound(
			'score',
			'jumper/Punktacja.mp3',
			0.5,
			false,
			false
		);

		SJ.mainMenuSoundContainer = new SJ.SoundContainer('mainMenuSoundContainer');
		SJ.soundManager.addContainer(SJ.mainMenuSoundContainer);

		SJ.mainMenuSoundContainer.createSound(
			'mouseClick',
			'Klik.mp3',
			0.07,
			false,
			false,
			null,
			null,
			null,
			null,
			null,
			null,
			null,
			true
		);
		SJ.mainMenuSoundContainer.createSound(
			'bank',
			'main-menu/Bank.mp3',
			0.1,
			false,
			false
		);
		SJ.mainMenuSoundContainer.createSound(
			'fameGallery',
			'main-menu/Galeria Slawy.mp3',
			0.05,
			false,
			false
		);
		SJ.mainMenuSoundContainer.createSound(
			'VIPClub',
			'main-menu/Klub VIP.mp3',
			0.1,
			false,
			false
		);
		SJ.mainMenuSoundContainer.createSound(
			'tournaments',
			'main-menu/Lotnisko.mp3',
			0.1,
			false,
			false
		);
		SJ.mainMenuSoundContainer.createSound(
			'worldCup',
			'main-menu/Skocznia.mp3',
			0.2,
			false,
			false
		);
		SJ.mainMenuSoundContainer.createSound(
			'tutorial',
			'main-menu/Tutorial.mp3',
			0.1,
			false,
			false
		);
		SJ.mainMenuSoundContainer.createSound(
			'settings',
			'main-menu/Ustawienia.mp3',
			0.1,
			false,
			false
		);
		SJ.mainMenuSoundContainer.createSound(
			'career',
			'main-menu/Villa.mp3',
			0.1,
			false,
			false
		);
		SJ.mainMenuSoundContainer.createSound(
			'shop',
			'main-menu/Warsztat.mp3',
			0.1,
			false,
			false
		);
		SJ.mainMenuSoundContainer.createSound(
			'logOut',
			'main-menu/Wylogowanie.mp3',
			0.2,
			false,
			false
		);
		SJ.mainMenuSoundContainer.createSound(
			'tutorial',
			'main-menu/Tutorial.mp3',
			0.1,
			false,
			false
		);

		SJ.weatherSoundContainer = new SJ.SoundContainer('weatherSoundContainer');
		SJ.SFXSoundManager.addContainer(SJ.weatherSoundContainer);

		SJ.weatherSoundContainer.createSound(
			'slowWind',
			'weather/Wiatr wolny.mp3',
			0.06,
			true,
			false
		);
		SJ.weatherSoundContainer.createSound(
			'fastWind',
			'weather/Wiatr szybki.mp3',
			0.06,
			true,
			false
		);
		SJ.weatherSoundContainer.createSound(
			'lightRain',
			'weather/Deszcz lekki.mp3',
			0.5,
			true,
			false
		);
		SJ.weatherSoundContainer.createSound(
			'heavyRain',
			'weather/Deszcz intensywny.mp3',
			0.25,
			true,
			false
		);
		SJ.weatherSoundContainer.createSound(
			'lightning1',
			'weather/Piorun 1.mp3',
			0.2,
			false,
			false
		);
		SJ.weatherSoundContainer.createSound(
			'lightning2',
			'weather/Piorun 2.mp3',
			0.2,
			false,
			false
		);
		SJ.weatherSoundContainer.createSound(
			'lightning3',
			'weather/Piorun 3.mp3',
			0.2,
			false,
			false
		);
		SJ.weatherSoundContainer.createSound(
			'lightning4',
			'weather/Piorun 4.mp3',
			0.2,
			false,
			false
		);

		SJ.crowdSoundContainer = new SJ.SoundContainer('crowdSoundContainer');
		SJ.SFXSoundManager.addContainer(SJ.crowdSoundContainer);

		SJ.crowdSoundContainer.createSound(
			'crowdShortJump1',
			'crowd/Tlum - ladowanie blisko.mp3',
			0.1,
			false,
			false
		);
		SJ.crowdSoundContainer.createSound(
			'crowdShortJump2',
			'crowd/Tlum - ladowanie blisko 2.mp3',
			0.1,
			false,
			false
		);
		SJ.crowdSoundContainer.createSound(
			'crowdShortJump3',
			'crowd/Tlum - ladowanie blisko 3.mp3',
			0.1,
			false,
			false
		);

		SJ.crowdSoundContainer.createSound(
			'crowdLongJump1',
			'crowd/Tlum - ladowanie daleko 1.mp3',
			0.1,
			false,
			false
		);
		SJ.crowdSoundContainer.createSound(
			'crowdLongJump2',
			'crowd/Tlum - ladowanie daleko 2.mp3',
			0.1,
			false,
			false
		);
		SJ.crowdSoundContainer.createSound(
			'crowdLongJump3',
			'crowd/Tlum - ladowanie daleko 3.mp3',
			0.1,
			false,
			false
		);

		SJ.crowdSoundContainer.createSound(
			'crowdFail1',
			'crowd/Tlum - upadek 1.mp3',
			0.15,
			false,
			false
		);
		SJ.crowdSoundContainer.createSound(
			'crowdFail2',
			'crowd/Tlum - upadek 2.mp3',
			0.15,
			false,
			false
		);
		SJ.crowdSoundContainer.createSound(
			'crowdFail3',
			'crowd/Tlum - upadek 3.mp3',
			0.15,
			false,
			false
		);

		SJ.crowdSoundContainer.createSound(
			'buzzer',
			'Syrena.mp3',
			0.1,
			false,
			false
		);

		SJ.playerData.checkPlayerDataInSessionStorage(() => {
			SJ.itemsManager = new SJ.ItemsManager();
			SJ.itemsManager.createActiveItems();
			SJ.itemsManager.loadItemsFromDB(() => {
				SJ.ScreensManager.setup();
				SJ.movingObjects = new SJ.MovingObjects();

				SJ.mainSoundtrack = new SJ.Sound(
					'mainSoundtrack',
					'main.mp3',
					0.000001,
					true,
					true,
					null,
					null,
					null,
					null,
					null,
					null,
					() => {
						window.setTimeout(() => SJ.mainSoundtrack.setVolume(0.03, 5), 100);
					}
				);
				SJ.soundManager.addSound(SJ.mainSoundtrack);

				if (!SJ.settings.music) {
					SJ.mainSoundtrack.pause();
					SJ.mainSoundtrack.autoPlay = false;
				}

				SJ._enterScreen(SJ.ScreensManager.screens.mainMenu);



			});
		});
	});
};

window.draw = function () {
	SJ.draw();

	SJ.FPS = frameRate();

	// textSize(20);
	// fill(255, 0, 0);
	// text("FPS: " + SJ.FPS.toFixed(), SJ.SCREEN_WIDTH - 250, 120);

	// document.body.style.cursor = ;
};

SJ._loadScripts = (callback) => callback();
SJ._loadEngine = (callback) => callback();
SJ._loadGame = (callback) => callback();

SJ._enterScreen = (screen) => {
	SJ._state = SJ._STATE.MENU;

	if (screen != SJ.ScreensManager.screens.game) {
		SJ.ScreensManager.changeScreen(screen);
	} else {
		console.error(
			"Cannot enter game directly from '_enterScreen' function. Use '_startGame' instead."
		);
		SJ._enterScreen(SJ.ScreensManager.screens.mainMenu);
	}
};

SJ._startGame = (fileName, locationName) => {
	console.log('');
	console.log(`%c -----LOADING MAP: ${locationName}-----`, 'color: orange');
	console.log('');

	SJ.mouseMoveEnable = false;

	SJ.mainSoundtrack.easyPause(3);

	SJ.LoadingScreen.setLoadingImage(locationName);
	SJ.LoadingScreen.reset();

	SJ.gameSoundsContainer.destruct();

	SJ.currentLocationName =
		locationName === 'Pekin2030' ? 'Pekin 2030' : locationName;

	SJ.LocationManager.changeLocation(fileName, () => {
		SJ.itemsManager.setDefaultVarValues();

		if (SJ.V.mapType === 'ski') {
			SJ.Jumper = SJ.SkiJumper;
			SJ.LaunchingPad = SJ.SkiLaunchingPad;
		} else {
			SJ.Jumper = SJ.SpaceJumper;
			SJ.LaunchingPad = SJ.SpaceLaunchingPad;
		}

		SJ.main = new SJ.MainClass();
		SJ.main.init();

		// console.log('BEFORE EQUIP ITEMS');
		// SJ.V.showWorldVariables();
		// console.log('-------------');

		SJ.LoadingScreen.remainingToLoad = SJ.LoadingScreen.imagesToLoad;

		SJ.playerData.setCurrentMapRecords(locationName);

		SJ._isGameReady = true;
		SJ.ScreensManager.changeScreen(SJ.ScreensManager.screens.game);

		// console.log('AFTER EQUIP ITEMS');
		// SJ.V.showWorldVariables();
		// console.log('-------------');

		SJ.itemsManager.equipAllItems();
		SJ.slidersManager.setDefaultValues();

		SJ._state = SJ._STATE.GAME;
	});
};

SJ._startTournament = (name, mapsArray, seriesCount) => {
	SJ.tournament = new SJ.Tournament(name, mapsArray, seriesCount);
};

SJ._endTournament = () => {
	SJ.tournament = null;
	SJ.pauseMenu.restartBtn.disabled = false;
};

SJ.backToMenu = () => {
	SJ.main.destruct();
	SJ.main = null;
	SJ._isGameReady = false;
	SJ._enterScreen(SJ.ScreensManager.screens.mainMenu);
	SJ.itemsManager.unequipAllItems();

	SJ.gameSoundsContainer.destruct();
	SJ.weatherSoundContainer.stop();
	SJ.jumperSoundContainer.stop();

	if (SJ.settings.music) SJ.mainSoundtrack.easyPlay(3);
};

SJ.draw = () => {
	if (SJ._state == SJ._STATE.LOADING) {
		return;
	}

	SJ.canvasScaler.transform();

	switch (SJ._state) {
		case SJ._STATE.MENU:
			SJ.ScreensManager.draw();
			break;

		case SJ._STATE.GAME:
			SJ.main.draw();

			if (SJ._wantRestartGame) {
				SJ._wantRestartGame = false;
				SJ.main._restartGame();
			}

			SJ.ScreensManager.draw();

			if (
				SJ.LoadingScreen.remainingToLoad < 1 &&
				!SJ.LoadingScreen.afterLoadingDone
			)
				SJ.LoadingScreen.toDoAfterLoading();
			break;
	}

	if (SJ.LoadingScreen.isVisible) SJ.LoadingScreen.draw();

	// SJ.soundManager._update();
};

SJ.restartGame = () => {
	SJ._wantRestartGame = true;
};
